import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { getStatusValue } from "../../Centers/utilities";
import { allSharedComponents } from "../../../../../shared";
import {
  paymentActions,
  instructorActions,
  centersActions,
  SubscriptionActions,
  authActions,
} from "../../../../../redux/actions";
import {
  countryConstants,
  documentTypeConstants,
  translationConstants,
  centerStatusConstants,
  Directions,
  CenterStatusEnum,
  paymentType,
  initialGridStateForParams,
  documentStatusConstants,
} from "../../../../../constants";
import {
  RejectIcon,
  TickIcon,
  TwitterIcon,
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TiktokIcon,
  CenterLogoPlaceHolder,
  MapIcon,
  InstructorIcon,
  ClockStopWatchIcon,
  StudentIcon,
  MinusIcon,
  EnableIcon,
  SailingBoatIcon,
} from "../../../../../assets/images/icon";

import GeneralTabSideView from "../Components/GeneralTabSideView";
import GeneralTabForm from "../Components/GeneralTabForm";
import RejectModal from "../Modals/RejectModal";
import { AddProfileImage } from "../../../../../assets/images/icon/iconsProvider";

const { CustomModal, ReviewStars } = allSharedComponents;

const GeneralTab = ({ isAdmin, centerId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [saveCardCheck, setSaveCardCheck] = useState(
    new URLSearchParams(location?.search)?.get("saveCard")
  );
  const [urlCheckoutId, setUrlCheckoutId] = useState(
    new URLSearchParams(location?.search)?.get("id")
  );
  let centerLogo = useSelector((state) => state.centersReducer.centerLogo);
  const formState = useSelector(
    (state) => state.centersReducer.centerProfileData
  );

  const isViewModalOpen = useSelector(
    (state) => state.InstructorReducer.isViewModalOpen
  );
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );
  const userData = useSelector((state) => state?.LoginReducer?.UserData);

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      dispatch(centersActions.setCenterLogoPreview(e.target.result));
    };
    reader.readAsDataURL(file[0]);
    const formData = new FormData();
    formData.append("DocumentTypeId", documentTypeConstants.CENTER_LOGO);
    formData.append("CenterId", centerId);
    formData.append("File", file[0]);
    dispatch(centersActions.uploadCenterLogo(formData, centerId));
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleFileUpload,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png"],
    },
    multiple: true,
  });

  useEffect(() => {
    dispatch(authActions.fetchCountries());
    dispatch(authActions.fetchCities(countryConstants.SAUDIA_ARABIA));
    dispatch(centersActions.getCenterById(centerId));
    dispatch(centersActions.getCenterLogo(centerId));
    // eslint-disable-next-line
  }, []);

  const onSetShow = (heading) => {
    setTitle(heading);
    dispatch(instructorActions.toggleViewModal(!isViewModalOpen));
  };

  const handleApproval = (isNafes) => {
    const dataToSend = {
      requestType: isNafes
        ? documentStatusConstants.APPROVED
        : documentStatusConstants.REJECTED,
      centerId: centerId,
      centerEmail: formState?.centerUserInfo[0]?.email,
      centerStatus: isNafes
        ? formState.centerStatus
        : CenterStatusEnum.PaymentPending,
      nafesStatus: isNafes
        ? documentStatusConstants.APPROVED
        : formState.nafesStatus,
      nafesDocumentStatus: documentStatusConstants.APPROVED,
    };
    dispatch(centersActions.approveCenters(dataToSend));
  };

  const centerPaymentModalHandler = (data) => {
    dispatch(centersActions.toggleCenterRepaymentModal(data));
  };

  useEffect(() => {
    if (urlCheckoutId) {
      navigate(location.pathname);
      setUrlCheckoutId(null);
      centerPaymentModalHandler(false);
      if (saveCardCheck) {
        dispatch(
          paymentActions.saveCard(urlCheckoutId, {
            centerId: userData?.user?.centerId,
          })
        );
      } else {
        dispatch(
          centersActions.centerPayment(urlCheckoutId, () => {
            dispatch(
              authActions.setCenterStatusInLoginReducer(
                CenterStatusEnum.Approved
              )
            );
            dispatch(
              paymentActions.paymentHistory({
                centerId: userData?.user?.centerId,
                paymentType: paymentType.Center,
                params: initialGridStateForParams,
              })
            );
            dispatch(paymentActions.paymentCheckoutNull());
            dispatch(centersActions.getCenterById(userData?.user?.centerId));
          })
        );
      }
    }
    setSaveCardCheck(null);
    // eslint-disable-next-line
  }, [urlCheckoutId]);

  useEffect(() => {
    dispatch(
      SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
    );
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="row w-100">
        <div className="col-md-8">
          <div className="general-tab center-profile reset-max-width">
            <div className="px-2 d-flex flex-wrap align-items-end justify-content-between mb-4">
              <div className="row m-0 w-100">
                <div className=" col-md-6 px-0 d-flex align-items-end mb-2 mb-lg-0">
                  <div className="mt-3 profile-img d-flex align-items-center">
                    <img
                      alt="avatar"
                      className="avatar border-radius-0 h-120"
                      src={
                        centerLogo !== null ? centerLogo : CenterLogoPlaceHolder
                      }
                    />
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <span
                        className={`plus-icon-con add-img-icon-pos${
                          isAdmin ? " d-none" : ""
                        }`}
                      >
                        <AddProfileImage />
                      </span>
                    </div>
                  </div>
                  <h6 className="verify-doc fs-24">
                    {direction === Directions.rtl &&
                    formState?.centerInfo?.arabicName
                      ? formState?.centerInfo?.arabicName
                      : formState?.centerInfo?.name}
                  </h6>
                </div>
                <div className=" col-md-6 px-0 d-flex flex-column justify-content-md-end align-items-md-end mb-2">
                  {isAdmin &&
                    getStatusValue(formState?.centerStatus) ===
                      centerStatusConstants.PENDING_CENTER && (
                      <div className="d-flex align-items-center my-2">
                        <Button
                          className="approve-button mx-1 my-20"
                          type="button"
                          onClick={() => {
                            handleApproval();
                          }}
                        >
                          <img
                            src={TickIcon}
                            alt="approveIcon"
                            className="pe-1"
                            name="approved"
                            height={18}
                          />
                          {t(translationConstants.Approve)}
                        </Button>
                        <Button
                          className="reject-button mx-1 my-20"
                          type="button"
                          onClick={() => {
                            onSetShow(translationConstants.REJECT_CENTER);
                          }}
                        >
                          <img
                            src={RejectIcon}
                            name="rejected"
                            height={18}
                            alt=""
                            className="pe-1"
                          />
                          {t(translationConstants.Reject)}
                        </Button>
                      </div>
                    )}

                  {isAdmin &&
                    (getStatusValue(formState?.centerStatus) ===
                      centerStatusConstants.APPROVED ||
                      getStatusValue(formState?.centerStatus) ===
                        centerStatusConstants.PAYMENT_PENDING) && (
                      <div className="d-flex align-items-center my-2">
                        <button
                          className="disable-button mx-1 my-20"
                          type="button"
                          onClick={() => {
                            dispatch(
                              centersActions.enableDisableCenter(centerId)
                            );
                          }}
                        >
                          <img
                            src={MinusIcon}
                            name="rejected"
                            height={18}
                            alt=""
                            className="pe-1"
                          />
                          {t(translationConstants.DISABLE)}
                        </button>
                      </div>
                    )}

                  {isAdmin &&
                    getStatusValue(formState?.centerStatus) ===
                      centerStatusConstants.DISABLED && (
                      <div className="user-profile d-flex align-items-center my-2 ">
                        <button
                          className="profile-button btn-primary  mx-1"
                          type="button"
                          onClick={() => {
                            dispatch(
                              centersActions.enableDisableCenter(centerId)
                            );
                          }}
                        >
                          <img
                            src={EnableIcon}
                            name="rejected"
                            height={14}
                            alt=""
                            className="pe-1"
                          />
                          {t(translationConstants.ENABLE)}
                        </button>
                      </div>
                    )}

                  <div className="d-flex mx-1 px-1">
                    {formState?.centerInfo?.twitterURL && (
                      <a
                        href={formState?.centerInfo?.twitterURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`bg-none`}
                      >
                        <img
                          src={TwitterIcon}
                          alt=""
                          className="pe-1"
                          name="approved"
                          height={22}
                        />
                      </a>
                    )}
                    {formState?.centerInfo?.linkedInURL && (
                      <a
                        href={formState?.centerInfo?.linkedInURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`bg-none}`}
                      >
                        <img
                          src={LinkedinIcon}
                          alt=""
                          className="pe-1"
                          name="approved"
                          height={22}
                        />
                      </a>
                    )}
                    {formState?.centerInfo?.facebookURL && (
                      <a
                        href={formState?.centerInfo?.facebookURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`bg-none`}
                      >
                        <img
                          src={FacebookIcon}
                          alt=""
                          className="pe-1"
                          name="approved"
                          height={22}
                        />
                      </a>
                    )}
                    {formState?.centerInfo?.instagramURL && (
                      <a
                        href={formState?.centerInfo?.instagramURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`bg-none`}
                      >
                        <img
                          src={InstagramIcon}
                          alt=""
                          className="pe-1"
                          name="approved"
                          height={22}
                        />
                      </a>
                    )}
                    {formState?.centerInfo?.tikTokURL && (
                      <a
                        href={formState?.centerInfo?.tikTokURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`bg-none`}
                      >
                        <img
                          src={TiktokIcon}
                          alt=""
                          className="pe-1"
                          name="approved"
                          height={22}
                        />
                      </a>
                    )}
                  </div>
                </div>
                <div className="d-block d-md-none">
                  <div className="d-flex justify-content-end px-4">
                    <ReviewStars value={formState?.overallRating} size={5} />
                  </div>
                  <div className="d-flex justify-content-end pt-1 px-4 theme-text-color">
                    {formState?.noOfReviews} {t(translationConstants.REVIEWS)}
                  </div>
                </div>
              </div>
            </div>

            {!isAdmin && (
              <div className="container mb-4">
                <div className="row">
                  <div className="col-lg col-4 centerBox">
                    <div className="box">
                      <img src={SailingBoatIcon} alt="Sailing" />
                      <h6>{t(translationConstants.SPORTS)}</h6>
                      <p>{formState?.noOfSports}</p>
                    </div>
                  </div>
                  <div className="col-lg col-4 centerBox">
                    <div className="box">
                      <img src={StudentIcon} alt="Grad Student" />
                      <h6>{t(translationConstants.STUDENTS)}</h6>
                      <p>{formState?.noOfStudents}</p>
                    </div>
                  </div>
                  <div className="col-lg col-4 centerBox">
                    <div className="box">
                      <img src={InstructorIcon} alt="Instructors" />
                      <h6>{t(translationConstants.INSTRUCTORS)}</h6>
                      <p>{formState?.noOfInstructors}</p>
                    </div>
                  </div>
                  <div className="col-lg col-4 centerBox">
                    <div className="box">
                      <img src={MapIcon} alt="Locations" />
                      <h6>{t(translationConstants.LOCATIONS)}</h6>
                      <p>{formState?.noOfSpots}</p>
                    </div>
                  </div>
                  <div className="col-lg col-4 centerBox">
                    <div className="box">
                      <img src={ClockStopWatchIcon} alt="Clock" />
                      <h6>{t(translationConstants.HOURS)}</h6>
                      <p>{formState?.noOfHours}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <GeneralTabForm isAdmin={isAdmin} centerId={centerId} />
          </div>
        </div>

        <div className="col-md-4 border-vr mt-90">
          <GeneralTabSideView
            isAdmin={isAdmin}
            centerId={centerId}
            handleNafesApproval={handleApproval}
          />
        </div>
      </div>

      <CustomModal
        scrollable={true}
        size="lg"
        setShow={onSetShow}
        show={isViewModalOpen}
        customClass="view-user-modal"
      >
        <RejectModal title={title} centerId={centerId} formState={formState} />
      </CustomModal>
    </>
  );
};

export default GeneralTab;
